import {ITextFieldProps, TextField} from "@fluentui/react";
import React from "react";
import {useErrorMessage} from "../hooks/useErrorMessage";

export const TextFieldWithError = (props: ITextFieldProps) => {
    const {localErrorMessage, clearLocalErrorMessage} = useErrorMessage(
        props.errorMessage,
    );

    return (
        <TextField
            {...props}
            errorMessage={localErrorMessage}
            onFocus={(e) => {
                clearLocalErrorMessage();
                props.onFocus?.(e);
            }}
        />
    );
};
